import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const EmailLogService = {
    getAll: async () => {
        try {
            const response = await apiService.get("/emaillogs");
            return response.data;
        } catch (error) {
            console.log(error);
        }
    },
    getById: async (id) => {
        try {
            const response = await apiService.get(`/emaillogs/${id}`);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    },

};

export default EmailLogService;
